import { nextTick, useCookie } from '#imports';

export const getDate = (days) => {
  if (! days) {
    return undefined;
  }

  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  return date;
}

export const getCookie = (cookieName) => {
  return setCookie(cookieName);
}

export const setCookie = async (cookieName, value = '', duration) => {
  let cookieOptions = {}
  if (duration) {
    cookieOptions = {
      expires: getDate(duration),
      path: '/',
      secure: true,
      sameSite: 'strict'
    }
  }
  const token = useCookie(cookieName, cookieOptions)

  token.value = value

  await nextTick();
}

export const invalidateCookie = (cookieName) => {
  const token = useCookie(cookieName);
  token.value = null;
}
